// Campaign Reducer
import {
  GET_CAMPAIGNS,
  GET_CAMPAIGNS_SUCCESS,
  GET_CAMPAIGNS_FAIL,
  GET_CAMPAIGNS_RESET,
  CREATE_CAMPAIGN,
  CREATE_CAMPAIGN_SUCCESS,
  CREATE_CAMPAIGN_FAIL,
  CREATE_CAMPAIGN_RESET,
  GET_CAMPAIGN_BY_ID,
  GET_CAMPAIGN_BY_ID_SUCCESS,
  GET_CAMPAIGN_BY_ID_FAIL,
  GET_CAMPAIGN_BY_ID_RESET,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_FAIL,
  UPDATE_CAMPAIGN_RESET,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_FAIL,
  DELETE_CAMPAIGN_RESET,
  PUBLISH_CAMPAIGN,
  PUBLISH_CAMPAIGN_SUCCESS,
  PUBLISH_CAMPAIGN_FAIL,
  PUBLISH_CAMPAIGN_RESET,
  PUBLISH_TO_PURESPECTRUM,
  PUBLISH_TO_PURESPECTRUM_SUCCESS,
  PUBLISH_TO_PURESPECTRUM_FAIL,
  PUBLISH_TO_PURESPECTRUM_RESET,
  LAUNCH_CAMPAIGN,
  LAUNCH_CAMPAIGN_SUCCESS,
  LAUNCH_CAMPAIGN_FAIL,
  LAUNCH_CAMPAIGN_RESET,
  PAUSE_CAMPAIGN,
  PAUSE_CAMPAIGN_SUCCESS,
  PAUSE_CAMPAIGN_FAIL,
  PAUSE_CAMPAIGN_RESET,
  RESUME_CAMPAIGN,
  RESUME_CAMPAIGN_SUCCESS,
  RESUME_CAMPAIGN_FAIL,
  RESUME_CAMPAIGN_RESET,
  CLOSE_CAMPAIGN,
  CLOSE_CAMPAIGN_SUCCESS,
  CLOSE_CAMPAIGN_FAIL,
  CLOSE_CAMPAIGN_RESET,
  FORCE_CLOSE_CAMPAIGN,
  FORCE_CLOSE_CAMPAIGN_SUCCESS,
  FORCE_CLOSE_CAMPAIGN_FAIL,
  FORCE_CLOSE_CAMPAIGN_RESET,
  SYNC_CAMPAIGN,
  SYNC_CAMPAIGN_SUCCESS,
  SYNC_CAMPAIGN_FAIL,
  SYNC_CAMPAIGN_RESET,
  UPDATE_CPI,
  UPDATE_CPI_SUCCESS,
  UPDATE_CPI_FAIL,
  UPDATE_CPI_RESET,
  GET_PS_STATS,
  GET_PS_STATS_SUCCESS,
  GET_PS_STATS_FAIL,
  GET_PS_STATS_RESET,
  // Campaign Calls
  GET_CAMPAIGN_CALLS,
  GET_CAMPAIGN_CALLS_SUCCESS,
  GET_CAMPAIGN_CALLS_FAIL,
  GET_CAMPAIGN_CALLS_RESET,
  GET_CALL_TRANSCRIPT,
  GET_CALL_TRANSCRIPT_SUCCESS,
  GET_CALL_TRANSCRIPT_FAIL,
  GET_CALL_TRANSCRIPT_RESET,
  GET_TRANSCRIPT_STATS,
  GET_TRANSCRIPT_STATS_SUCCESS,
  GET_TRANSCRIPT_STATS_FAIL,
  GET_TRANSCRIPT_STATS_RESET,
  PROCESS_CAMPAIGN_TRANSCRIPTS,
  PROCESS_CAMPAIGN_TRANSCRIPTS_SUCCESS,
  PROCESS_CAMPAIGN_TRANSCRIPTS_FAIL,
  PROCESS_CAMPAIGN_TRANSCRIPTS_RESET,
  RETRY_FAILED_TRANSCRIPTS,
  RETRY_FAILED_TRANSCRIPTS_SUCCESS,
  RETRY_FAILED_TRANSCRIPTS_FAIL,
  RETRY_FAILED_TRANSCRIPTS_RESET,
  UPDATE_CALL_QUALITY,
  UPDATE_CALL_QUALITY_SUCCESS,
  UPDATE_CALL_QUALITY_FAIL,
  UPDATE_CALL_QUALITY_RESET,
  GET_CALL_AUDIO,
  GET_CALL_AUDIO_SUCCESS,
  GET_CALL_AUDIO_FAIL,
  GET_CALL_AUDIO_RESET,
  REFRESH_CALL_ITEM,
  REFRESH_CALL_ITEM_SUCCESS,
  REFRESH_CALL_ITEM_FAIL,
  REFRESH_CALL_ITEM_RESET,
  REPROCESS_CALL,
  REPROCESS_CALL_SUCCESS,
  REPROCESS_CALL_FAIL,
  REPROCESS_CALL_RESET,
  BULK_REPROCESS_CALLS,
  BULK_REPROCESS_CALLS_SUCCESS,
  BULK_REPROCESS_CALLS_FAIL,
  BULK_REPROCESS_CALLS_RESET,
  TOGGLE_CALL_STAR,
  TOGGLE_CALL_STAR_SUCCESS,
  TOGGLE_CALL_STAR_FAIL,
  TOGGLE_CALL_STAR_RESET,
  GET_ELEVENLABS_CREDITS,
  GET_ELEVENLABS_CREDITS_SUCCESS,
  GET_ELEVENLABS_CREDITS_FAIL,
  GET_ELEVENLABS_CREDITS_RESET,
} from '../actions/campaignAction';

const initialState = {
  // Get Campaigns
  getCampaignsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Create Campaign
  createCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Get Campaign By ID
  getCampaignByIdState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Update Campaign
  updateCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Delete Campaign
  deleteCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Publish Campaign
  publishCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // PureSpectrum Integration States
  publishToPureSpectrumState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  launchCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  pauseCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  resumeCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  closeCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  forceCloseCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  syncCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateCPIState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getPureSpectrumStatsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Campaign Calls
  getCampaignCallsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getCallTranscriptState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getTranscriptStatsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  processCampaignTranscriptsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  retryFailedTranscriptsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateCallQualityState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
    callId: null,
    quality: null,
  },
  getCallAudioState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
    callId: null,
  },
  // Refresh Call Item
  refreshCallItemState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
    callId: null,
    itemType: null,
  },
  // Reprocess Call
  reprocessCallState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
    callId: null,
  },
  // Bulk Reprocess Calls
  bulkReprocessCallsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Toggle Call Star
  toggleCallStarState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
    callId: null,
  },
  // Eleven Labs Credits
  getElevenLabsCreditsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const campaignReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Campaigns
    case GET_CAMPAIGNS:
      return {
        ...state,
        getCampaignsState: {
          ...state.getCampaignsState,
          apiState: 'loading',
        },
      };
    case GET_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        getCampaignsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Studies retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CAMPAIGNS_FAIL:
      return {
        ...state,
        getCampaignsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch studies',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CAMPAIGNS_RESET:
      return {
        ...state,
        getCampaignsState: initialState.getCampaignsState,
      };

    // Create Campaign
    case CREATE_CAMPAIGN:
      return {
        ...state,
        createCampaignState: {
          ...state.createCampaignState,
          apiState: 'loading',
        },
      };
    case CREATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        createCampaignState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Study created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_CAMPAIGN_FAIL:
      return {
        ...state,
        createCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_CAMPAIGN_RESET:
      return {
        ...state,
        createCampaignState: initialState.createCampaignState,
      };

    // Get Campaign By ID
    case GET_CAMPAIGN_BY_ID:
      return {
        ...state,
        getCampaignByIdState: {
          ...state.getCampaignByIdState,
          apiState: 'loading',
        },
      };
    case GET_CAMPAIGN_BY_ID_SUCCESS:
      return {
        ...state,
        getCampaignByIdState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Study retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CAMPAIGN_BY_ID_FAIL:
      return {
        ...state,
        getCampaignByIdState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CAMPAIGN_BY_ID_RESET:
      return {
        ...state,
        getCampaignByIdState: initialState.getCampaignByIdState,
      };

    // Update Campaign
    case UPDATE_CAMPAIGN:
      return {
        ...state,
        updateCampaignState: {
          ...state.updateCampaignState,
          apiState: 'loading',
        },
      };
    case UPDATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        updateCampaignState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Study updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_CAMPAIGN_FAIL:
      return {
        ...state,
        updateCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_CAMPAIGN_RESET:
      return {
        ...state,
        updateCampaignState: initialState.updateCampaignState,
      };

    // Delete Campaign
    case DELETE_CAMPAIGN:
      return {
        ...state,
        deleteCampaignState: {
          ...state.deleteCampaignState,
          apiState: 'loading',
        },
      };
    case DELETE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        deleteCampaignState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Study deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_CAMPAIGN_FAIL:
      return {
        ...state,
        deleteCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_CAMPAIGN_RESET:
      return {
        ...state,
        deleteCampaignState: initialState.deleteCampaignState,
      };

    // Publish Campaign
    case PUBLISH_CAMPAIGN:
      return {
        ...state,
        publishCampaignState: {
          ...state.publishCampaignState,
          apiState: 'loading',
        },
      };
    case PUBLISH_CAMPAIGN_SUCCESS:
      return {
        ...state,
        publishCampaignState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Study published successfully',
          errors: action.response.errors || null,
        },
      };
    case PUBLISH_CAMPAIGN_FAIL:
      return {
        ...state,
        publishCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to publish study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case PUBLISH_CAMPAIGN_RESET:
      return {
        ...state,
        publishCampaignState: initialState.publishCampaignState,
      };

    // Publish to PureSpectrum
    case PUBLISH_TO_PURESPECTRUM:
      return {
        ...state,
        publishToPureSpectrumState: {
          ...state.publishToPureSpectrumState,
          apiState: 'loading',
        },
      };
    case PUBLISH_TO_PURESPECTRUM_SUCCESS:
      return {
        ...state,
        publishToPureSpectrumState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Study published successfully',
          errors: action.response.errors || null,
        },
      };
    case PUBLISH_TO_PURESPECTRUM_FAIL:
      return {
        ...state,
        publishToPureSpectrumState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to publish study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case PUBLISH_TO_PURESPECTRUM_RESET:
      return {
        ...state,
        publishToPureSpectrumState: initialState.publishToPureSpectrumState,
      };

    // Launch Campaign
    case LAUNCH_CAMPAIGN:
      return {
        ...state,
        launchCampaignState: {
          ...state.launchCampaignState,
          apiState: 'loading',
        },
      };
    case LAUNCH_CAMPAIGN_SUCCESS:
      return {
        ...state,
        launchCampaignState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Study launched successfully',
          errors: action.response.errors || null,
        },
      };
    case LAUNCH_CAMPAIGN_FAIL:
      return {
        ...state,
        launchCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to launch study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case LAUNCH_CAMPAIGN_RESET:
      return {
        ...state,
        launchCampaignState: initialState.launchCampaignState,
      };

    // Pause Campaign
    case PAUSE_CAMPAIGN:
      return {
        ...state,
        pauseCampaignState: {
          ...state.pauseCampaignState,
          apiState: 'loading',
        },
      };
    case PAUSE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        pauseCampaignState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Study paused successfully',
          errors: action.response.errors || null,
        },
      };
    case PAUSE_CAMPAIGN_FAIL:
      return {
        ...state,
        pauseCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to pause study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case PAUSE_CAMPAIGN_RESET:
      return {
        ...state,
        pauseCampaignState: initialState.pauseCampaignState,
      };

    // Resume Campaign
    case RESUME_CAMPAIGN:
      return {
        ...state,
        resumeCampaignState: {
          ...state.resumeCampaignState,
          apiState: 'loading',
        },
      };
    case RESUME_CAMPAIGN_SUCCESS:
      return {
        ...state,
        resumeCampaignState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Study resumed successfully',
          errors: action.response.errors || null,
        },
      };
    case RESUME_CAMPAIGN_FAIL:
      return {
        ...state,
        resumeCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to resume study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case RESUME_CAMPAIGN_RESET:
      return {
        ...state,
        resumeCampaignState: initialState.resumeCampaignState,
      };

    // Close Campaign
    case CLOSE_CAMPAIGN:
      return {
        ...state,
        closeCampaignState: {
          ...state.closeCampaignState,
          apiState: 'loading',
        },
      };
    case CLOSE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        closeCampaignState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Study closed successfully',
          errors: action.response.errors || null,
        },
      };
    case CLOSE_CAMPAIGN_FAIL:
      return {
        ...state,
        closeCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to close study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CLOSE_CAMPAIGN_RESET:
      return {
        ...state,
        closeCampaignState: initialState.closeCampaignState,
      };

    // Force Close Campaign
    case FORCE_CLOSE_CAMPAIGN:
      return {
        ...state,
        forceCloseCampaignState: {
          ...state.forceCloseCampaignState,
          apiState: 'loading',
        },
      };
    case FORCE_CLOSE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        forceCloseCampaignState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Study force closed successfully',
          errors: action.response.errors || null,
        },
      };
    case FORCE_CLOSE_CAMPAIGN_FAIL:
      return {
        ...state,
        forceCloseCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to force close study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case FORCE_CLOSE_CAMPAIGN_RESET:
      return {
        ...state,
        forceCloseCampaignState: initialState.forceCloseCampaignState,
      };

    // Sync Campaign
    case SYNC_CAMPAIGN:
      return {
        ...state,
        syncCampaignState: {
          ...state.syncCampaignState,
          apiState: 'loading',
        },
      };
    case SYNC_CAMPAIGN_SUCCESS:
      return {
        ...state,
        syncCampaignState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Study synced successfully',
          errors: action.response.errors || null,
        },
      };
    case SYNC_CAMPAIGN_FAIL:
      return {
        ...state,
        syncCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to sync study',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case SYNC_CAMPAIGN_RESET:
      return {
        ...state,
        syncCampaignState: initialState.syncCampaignState,
      };

    // Update CPI
    case UPDATE_CPI:
      return {
        ...state,
        updateCPIState: {
          ...state.updateCPIState,
          apiState: 'loading',
        },
      };
    case UPDATE_CPI_SUCCESS:
      return {
        ...state,
        updateCPIState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'CPI updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_CPI_FAIL:
      return {
        ...state,
        updateCPIState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update CPI',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_CPI_RESET:
      return {
        ...state,
        updateCPIState: initialState.updateCPIState,
      };

    // Get PureSpectrum Stats
    case GET_PS_STATS:
      return {
        ...state,
        getPureSpectrumStatsState: {
          ...state.getPureSpectrumStatsState,
          apiState: 'loading',
        },
      };
    case GET_PS_STATS_SUCCESS:
      return {
        ...state,
        getPureSpectrumStatsState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Stats retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_PS_STATS_FAIL:
      return {
        ...state,
        getPureSpectrumStatsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch stats',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_PS_STATS_RESET:
      return {
        ...state,
        getPureSpectrumStatsState: initialState.getPureSpectrumStatsState,
      };

    // Get Campaign Calls
    case GET_CAMPAIGN_CALLS:
      return {
        ...state,
        getCampaignCallsState: {
          ...state.getCampaignCallsState,
          apiState: 'loading',
        },
      };
    case GET_CAMPAIGN_CALLS_SUCCESS:
      return {
        ...state,
        getCampaignCallsState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Calls retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CAMPAIGN_CALLS_FAIL:
      return {
        ...state,
        getCampaignCallsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch calls',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CAMPAIGN_CALLS_RESET:
      return {
        ...state,
        getCampaignCallsState: initialState.getCampaignCallsState,
      };

    // Get Call Transcript
    case GET_CALL_TRANSCRIPT:
      return {
        ...state,
        getCallTranscriptState: {
          ...state.getCallTranscriptState,
          apiState: 'loading',
        },
      };
    case GET_CALL_TRANSCRIPT_SUCCESS:
      return {
        ...state,
        getCallTranscriptState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Transcript retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CALL_TRANSCRIPT_FAIL:
      return {
        ...state,
        getCallTranscriptState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch transcript',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CALL_TRANSCRIPT_RESET:
      return {
        ...state,
        getCallTranscriptState: initialState.getCallTranscriptState,
      };

    // Get Transcript Stats
    case GET_TRANSCRIPT_STATS:
      return {
        ...state,
        getTranscriptStatsState: {
          ...state.getTranscriptStatsState,
          apiState: 'loading',
        },
      };
    case GET_TRANSCRIPT_STATS_SUCCESS:
      return {
        ...state,
        getTranscriptStatsState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Stats retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_TRANSCRIPT_STATS_FAIL:
      return {
        ...state,
        getTranscriptStatsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch stats',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_TRANSCRIPT_STATS_RESET:
      return {
        ...state,
        getTranscriptStatsState: initialState.getTranscriptStatsState,
      };

    // Process Campaign Transcripts
    case PROCESS_CAMPAIGN_TRANSCRIPTS:
      return {
        ...state,
        processCampaignTranscriptsState: {
          ...state.processCampaignTranscriptsState,
          apiState: 'loading',
        },
      };
    case PROCESS_CAMPAIGN_TRANSCRIPTS_SUCCESS:
      return {
        ...state,
        processCampaignTranscriptsState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Transcripts processed successfully',
          errors: action.response.errors || null,
        },
      };
    case PROCESS_CAMPAIGN_TRANSCRIPTS_FAIL:
      return {
        ...state,
        processCampaignTranscriptsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to process transcripts',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case PROCESS_CAMPAIGN_TRANSCRIPTS_RESET:
      return {
        ...state,
        processCampaignTranscriptsState: initialState.processCampaignTranscriptsState,
      };

    // Retry Failed Transcripts
    case RETRY_FAILED_TRANSCRIPTS:
      return {
        ...state,
        retryFailedTranscriptsState: {
          ...state.retryFailedTranscriptsState,
          apiState: 'loading',
        },
      };
    case RETRY_FAILED_TRANSCRIPTS_SUCCESS:
      return {
        ...state,
        retryFailedTranscriptsState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Failed transcripts retried successfully',
          errors: action.response.errors || null,
        },
      };
    case RETRY_FAILED_TRANSCRIPTS_FAIL:
      return {
        ...state,
        retryFailedTranscriptsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to retry transcripts',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case RETRY_FAILED_TRANSCRIPTS_RESET:
      return {
        ...state,
        retryFailedTranscriptsState: initialState.retryFailedTranscriptsState,
      };

    // Update Call Quality
    case UPDATE_CALL_QUALITY:
      return {
        ...state,
        updateCallQualityState: {
          ...state.updateCallQualityState,
          apiState: 'loading',
        },
      };
    case UPDATE_CALL_QUALITY_SUCCESS:
      return {
        ...state,
        updateCallQualityState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Call quality updated successfully',
          errors: null,
          error: null,
          callId: action.callId,
          quality: action.quality,
        },
      };
    case UPDATE_CALL_QUALITY_FAIL:
      return {
        ...state,
        updateCallQualityState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update call quality',
          errors: action.response?.errors || null,
          error: action.response,
          callId: null,
          quality: null,
        },
      };
    case UPDATE_CALL_QUALITY_RESET:
      return {
        ...state,
        updateCallQualityState: initialState.updateCallQualityState,
      };

    // Get Call Audio
    case GET_CALL_AUDIO:
      return {
        ...state,
        getCallAudioState: {
          ...state.getCallAudioState,
          apiState: 'loading',
        },
      };
    case GET_CALL_AUDIO_SUCCESS:
      return {
        ...state,
        getCallAudioState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Audio retrieved successfully',
          errors: null,
          error: null,
          callId: action.callId,
        },
      };
    case GET_CALL_AUDIO_FAIL:
      return {
        ...state,
        getCallAudioState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch audio',
          errors: action.response?.errors || null,
          error: action.response,
          callId: null,
        },
      };
    case GET_CALL_AUDIO_RESET:
      return {
        ...state,
        getCallAudioState: initialState.getCallAudioState,
      };

    // Refresh Call Item
    case REFRESH_CALL_ITEM:
      return {
        ...state,
        refreshCallItemState: {
          ...state.refreshCallItemState,
          apiState: 'loading',
          callId: action.callId,
          itemType: action.itemType,
        },
      };
    case REFRESH_CALL_ITEM_SUCCESS:
      return {
        ...state,
        refreshCallItemState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Item refreshed successfully',
          errors: null,
          error: null,
          callId: action.callId,
          itemType: action.itemType,
        },
      };
    case REFRESH_CALL_ITEM_FAIL:
      return {
        ...state,
        refreshCallItemState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to refresh item',
          errors: action.response?.errors || null,
          error: action.response,
          callId: action.callId,
          itemType: action.itemType,
        },
      };
    case REFRESH_CALL_ITEM_RESET:
      return {
        ...state,
        refreshCallItemState: initialState.refreshCallItemState,
      };

    // Reprocess Call
    case REPROCESS_CALL:
      return {
        ...state,
        reprocessCallState: {
          ...state.reprocessCallState,
          apiState: 'loading',
          callId: action.callId,
        },
      };
    case REPROCESS_CALL_SUCCESS:
      return {
        ...state,
        reprocessCallState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Call reprocessed successfully',
          errors: null,
          error: null,
          callId: action.callId,
        },
      };
    case REPROCESS_CALL_FAIL:
      return {
        ...state,
        reprocessCallState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to reprocess call',
          errors: action.response?.errors || null,
          error: action.response,
          callId: action.callId,
        },
      };
    case REPROCESS_CALL_RESET:
      return {
        ...state,
        reprocessCallState: initialState.reprocessCallState,
      };

    // Bulk Reprocess Calls
    case BULK_REPROCESS_CALLS:
      return {
        ...state,
        bulkReprocessCallsState: {
          ...state.bulkReprocessCallsState,
          apiState: 'loading',
        },
      };
    case BULK_REPROCESS_CALLS_SUCCESS:
      return {
        ...state,
        bulkReprocessCallsState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Bulk reprocess started',
          errors: null,
          error: null,
        },
      };
    case BULK_REPROCESS_CALLS_FAIL:
      return {
        ...state,
        bulkReprocessCallsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to start bulk reprocess',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case BULK_REPROCESS_CALLS_RESET:
      return {
        ...state,
        bulkReprocessCallsState: initialState.bulkReprocessCallsState,
      };

    // Toggle Call Star
    case TOGGLE_CALL_STAR:
      return {
        ...state,
        toggleCallStarState: {
          ...state.toggleCallStarState,
          apiState: 'loading',
          callId: action.callId,
        },
      };
    case TOGGLE_CALL_STAR_SUCCESS:
      return {
        ...state,
        toggleCallStarState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Call star toggled successfully',
          errors: null,
          error: null,
          callId: action.callId,
        },
      };
    case TOGGLE_CALL_STAR_FAIL:
      return {
        ...state,
        toggleCallStarState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to toggle call star',
          errors: action.response?.errors || null,
          error: action.response,
          callId: action.callId,
        },
      };
    case TOGGLE_CALL_STAR_RESET:
      return {
        ...state,
        toggleCallStarState: initialState.toggleCallStarState,
      };

    // Eleven Labs Credits
    case GET_ELEVENLABS_CREDITS:
      return {
        ...state,
        getElevenLabsCreditsState: {
          ...state.getElevenLabsCreditsState,
          apiState: 'loading',
        },
      };
    case GET_ELEVENLABS_CREDITS_SUCCESS:
      return {
        ...state,
        getElevenLabsCreditsState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Credits fetched successfully',
          errors: null,
          error: null,
        },
      };
    case GET_ELEVENLABS_CREDITS_FAIL:
      return {
        ...state,
        getElevenLabsCreditsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch credits',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ELEVENLABS_CREDITS_RESET:
      return {
        ...state,
        getElevenLabsCreditsState: initialState.getElevenLabsCreditsState,
      };

    default:
      return state;
  }
};

export default campaignReducer;

